import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-hot-toast';

export function useSubscriptionNavigation() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const navigateToSubscription = () => {
    if (!isAuthenticated) {
      toast.error('Please sign in to access subscription plans');
      navigate('/login', { state: { from: '/subscription' } });
      return;
    }
    navigate('/subscription');
  };

  return {
    navigateToSubscription
  };
}